import Vue from 'vue';
import App from './EPSApp.vue';
import vuetify from './plugins/vuetify';
import router from './router';

import VueMeta from "vue-meta";

Vue.use(VueMeta);

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
